import React from 'react';
import './LbsOzWeightInputs.css';

export interface LbsOzWeightInputsProps {
  readonly lbs: string;
  readonly oz: string;
  readonly lbsPlaceholder?: string;
  readonly ozPlaceholder?: string;
  readonly onLbsChange: (value: string) => void;
  readonly onOzChange: (value: string) => void;
  readonly onLbsFocus?: () => void;
  readonly onOzFocus?: () => void;
  readonly disabled?: boolean;
}

function LbsOzWeightInputs({
  lbs,
  oz,
  lbsPlaceholder,
  ozPlaceholder,
  onLbsChange,
  onOzChange,
  onLbsFocus,
  onOzFocus,
  disabled = false,
}: LbsOzWeightInputsProps): React.ReactElement {
  return (
    <div className="lbs-oz-weight-inputs">
      <label>
        <span>lb</span>
        <input
          type="number"
          min="0"
          step="0.01"
          value={lbs}
          placeholder={lbsPlaceholder}
          onChange={(event) => onLbsChange(event.target.value)}
          onFocus={onLbsFocus}
          disabled={disabled}
        />
      </label>
      <label>
        <span>oz</span>
        <input
          type="number"
          min="0"
          step="0.01"
          value={oz}
          placeholder={ozPlaceholder}
          onChange={(event) => onOzChange(event.target.value)}
          onFocus={onOzFocus}
          disabled={disabled}
        />
      </label>
    </div>
  );
}

export default LbsOzWeightInputs;
